/**
 * 应用路由配置
 * @module app/routes
 */

import React, { Suspense, lazy } from 'react';
import { createBrowserRouter, Navigate } from 'react-router-dom';
import { Spin } from 'antd';
import RouteErrorBoundary from './RouteErrorBoundary';

// 懒加载页面组件
const HomePage = lazy(() => import('@/features/home/HomePage'));
const RecycleBinPage = lazy(() => import('@/features/home/RecycleBinPage'));
const EditorPage = lazy(() => import('@/features/editor/EditorPage'));
const MarketplacePage = lazy(() => import('@/features/market/MarketplacePage'));
const MarketplaceDetailPage = lazy(() => import('@/features/market/MarketplaceDetailPage'));
const AdminPage = lazy(() => import('@/features/admin/AdminPage'));

// 加载中组件
const LoadingFallback: React.FC = () => (
  <div style={{ 
    display: 'flex', 
    flexDirection: 'column',
    justifyContent: 'center', 
    alignItems: 'center', 
    gap: 12,
    height: '100vh' 
  }}>
    <Spin size="large" />
    <span style={{ color: 'rgba(0, 0, 0, 0.65)' }}>加载中...</span>
  </div>
);

// 路由配置
export const router = createBrowserRouter([
  {
    path: '/',
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <HomePage />
      </Suspense>
    ),
    errorElement: <RouteErrorBoundary />,
  },
  {
    path: '/editor/:id',
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <EditorPage />
      </Suspense>
    ),
    errorElement: <RouteErrorBoundary />,
  },
  {
    path: '/recycle-bin',
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <RecycleBinPage />
      </Suspense>
    ),
    errorElement: <RouteErrorBoundary />,
  },
  {
    path: '/marketplace',
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <MarketplacePage />
      </Suspense>
    ),
    errorElement: <RouteErrorBoundary />,
  },
  {
    path: '/favorites',
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <MarketplacePage />
      </Suspense>
    ),
    errorElement: <RouteErrorBoundary />,
  },
  {
    path: '/marketplace/:id',
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <MarketplaceDetailPage />
      </Suspense>
    ),
    errorElement: <RouteErrorBoundary />,
  },
  {
    path: '/market',
    element: <Navigate to="/marketplace" replace />,
    errorElement: <RouteErrorBoundary />,
  },
  {
    path: '/market/:id',
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <MarketplaceDetailPage />
      </Suspense>
    ),
    errorElement: <RouteErrorBoundary />,
  },
  {
    path: '/admin',
    element: (
      <Suspense fallback={<LoadingFallback />}>
        <AdminPage />
      </Suspense>
    ),
    errorElement: <RouteErrorBoundary />,
  },
  {
    path: '*',
    element: <Navigate to="/" replace />,
    errorElement: <RouteErrorBoundary />,
  },
]);

export default router;
